// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"354":"2dc22d54","418":"e86bc327","668":"940a398c"}[chunkId] + ".js";
};